export default __webpack_public_path__ + "static/media/crepi.26b730a4.jpg";